export default __webpack_public_path__ + "static/media/team107.d85eb366.JPG";